import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Link as RLink, useLocation } from 'react-router-dom';

const RouterLink = styled(RLink)`
  &,color: black;
  text-decoration: none;
  text-decoration-color: black;

  &:visited {
    color: black;
  }
`;

const RefresherLink = styled.span`
  &,color: black;
  text-decoration: none;
  text-decoration-color: black;
`;

interface Props {
  children: ReactElement;
  url: string;
}

const Link = (props: Props): ReactElement => {
  const { children, url } = props;
  const { pathname } = useLocation();

  return pathname === url ? (
    <RefresherLink
      onClick={(): void => {
        window.location.reload();
      }}
    >
      {children}
    </RefresherLink>
  ) : (
    <RouterLink to={url}>{children}</RouterLink>
  );
};

export default Link;
